import React, { useContext, useEffect, useState, useMemo } from 'react';
import Swal from 'sweetalert2';

import usuariosContext from '../../context/usuarios/usuariosContext';
import AddItm from '../../components/addItm/AddItm';
import SearchInput from '../../components/searchInput/SearchInput';
import UsuarioRow from '../../components/usuarioRow/UsuarioRow';
import UsuarioForm from '../../components/usuarioForm/UsuarioForm';

import './Usuarios.css';

function Usuarios() {
    const uContext = useContext(usuariosContext);
    const { usuarios, getAllUsers, addUser, updateUser, deleteUser } = uContext;

    const [filter, setFilter] = useState('');
    const [openForm, setOpenForm] = useState(false);
    const [currentUsuario, setCurrentUsuario] = useState(null);

    useEffect(() => {
        getAllUsers();
    }, []);

    const handleOpenForm = (usuario = null) => {
        setCurrentUsuario(usuario);
        setOpenForm(true);
    };

    const handleCloseForm = () => {
        setOpenForm(false);
        setCurrentUsuario(null);
    };

    const handleSave = async (usuarioData) => {
        try {
            if (usuarioData._id) {
                await updateUser(usuarioData);
                Swal.fire('Éxito', 'Usuario actualizado correctamente', 'success');
            } else {
                await addUser(usuarioData);
                Swal.fire('Éxito', 'Usuario creado correctamente', 'success');
            }
            handleCloseForm();
            await getAllUsers();
        } catch (error) {
            Swal.fire('Error', error.message || 'Error al guardar usuario', 'error');
        }
    };

    const handleDelete = async (usuario) => {
        try {
            await deleteUser(usuario);
            Swal.fire('Eliminado', 'Usuario eliminado correctamente', 'success');
            await getAllUsers();
        } catch (error) {
            Swal.fire('Error', error.message || 'Error al eliminar usuario', 'error');
        }
    };

    const handleSearchInput = (value) => {
        setFilter(value);
    };

    const usuariosFiltered = useMemo(() => {
        if (!usuarios) return [];
        return usuarios.filter(u => {
            if (filter === '') return true;
            const filterLower = filter.toLowerCase();
            return (
                u.userName?.toLowerCase().includes(filterLower) ||
                u.fullName?.toLowerCase().includes(filterLower) ||
                u.email?.toLowerCase().includes(filterLower)
            );
        });
    }, [usuarios, filter]);

    if (usuarios === null) {
        return <h3 className="warningStatusMsg">Cargando <span>.</span><span>.</span><span>.</span></h3>;
    }

    return (
        <div className="usuariosList">
            <AddItm titulo={'Usuario'} anadiritm={handleOpenForm} />
            <SearchInput buscar={handleSearchInput} filter={filter} />

            {usuariosFiltered.length === 0 ? (
                <h3 className="warningStatusMsg">No hay usuarios cargados</h3>
            ) : (
                usuariosFiltered.map((usuario) => (
                    <UsuarioRow
                        key={usuario._id}
                        usuario={usuario}
                        onEdit={handleOpenForm}
                        onDelete={handleDelete}
                    />
                ))
            )}

            <UsuarioForm
                open={openForm}
                onClose={handleCloseForm}
                usuario={currentUsuario}
                onSave={handleSave}
            />
        </div>
    );
}

export default Usuarios;
